var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangeEmail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1244 9.09914C10.0858 9.12737 10.0387 9.14265 9.99022 9.14265C9.94176 9.14265 9.89462 9.12737 9.856 9.09914L3.94044 4.71143C3.62222 4.47571 3.80267 4 4.20978 4H15.7902C16.1982 4 16.3778 4.47571 16.0596 4.71143L10.1244 9.09914ZM18 6.99229V15.1583C18 15.6211 17.5796 16 17.0667 16H2.93333C2.42044 16 2 15.6211 2 15.1583V6.99143C2 6.63743 2.45778 6.44457 2.75556 6.66314L9.85067 11.7811C9.89476 11.8099 9.94677 11.8252 10 11.8252C10.0532 11.8252 10.1052 11.8099 10.1493 11.7811L17.2436 6.66314C17.5422 6.44457 18 6.63743 18 6.99143",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeEmail);
export default __webpack_public_path__ + "static/media/change-email.651c59cde4e0432d3845465c8a1de529.svg";
export { ForwardRef as ReactComponent };